import { render } from "./FrenteCaixaDescontoModal.vue?vue&type=template&id=46cfca4c&ts=true"
import script from "./FrenteCaixaDescontoModal.vue?vue&type=script&lang=ts"
export * from "./FrenteCaixaDescontoModal.vue?vue&type=script&lang=ts"

import "./FrenteCaixaDescontoModal.vue?vue&type=style&index=0&id=46cfca4c&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__